import call from './call';
import {GET_CONFIGURATION} from "../types";

export default () => async (dispatch) =>
{
    const onResult= (result) =>
    {
        if(result && result[1].success)
        {
            dispatch({type: GET_CONFIGURATION, payload: {configuration: result[1].results, total: result[1].total}});
        }

    };
    dispatch(call("SystemService/getAllConfigurationParams",{},onResult));
};